<template>
  <div id="trip">
    <div class="row mt-md-5 text-center">
      <div class="col-md-12 title-image">
        <img src="/static/images/trip/title.png" class="img-fluid" alt="おひさまキッチンのどうぶつさん達の画像">
      </div>
      <div class="col-md-12 text-left">
        <h2>
        おひさまキッチンの作家や制作チームが<br>
        読み聞かせ隊としておうかがいします！
        </h2>
        <p>手づくりの、おひさまキッチンアイテムや音楽につつまれて、ファンタジーが広がる絵本の世界を 体験しませんか！<br>
        幼稚園、保育園、小学校、本屋さん、ショピングセンター、子ども会のイベント、公園、森の中……。<br>
        いろいろなところにうかがいます。<br>
        少人数から大人数（３００人くらい）まで。<br>
        <br>
        お問合せは、<a href="mailto:koarakun@ohisamak-ehonya.com">こちら</a>でお願いします。</p>
      </div>
      <div class="col-md-12 line">
        <img src="/static/images/common/line.png" class="img-fluid" alt="黄色の破線">
      </div>
    </div>
    <div class="row mt-md-5 past">
      <div class="col-md-12 past-title">
        <img src="/static/images/trip/title-past.png" class="img-fluid" alt="おうかがいしました！">
      </div>
      <div class="col-6 past-event" v-for="trip in trips" >
        <router-link :to="{ name: 'EventArchive', params: { code: trip.code }}">
          <img :src="`/static/images/trip/archive/${trip.code}/${trip.image}`" class="img-fluid" :alt="`${trip.title}のサムネイル`">
        </router-link>
        <div class="detail row">
          <div class="date col-md-12">{{trip.date}}</div>
          <div class="title col-md-12" v-html="trip.title"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    title: 'よみきかせ隊がいきます！',
    name: 'trip',
    data() {
      return {
        trips: []
      };
    },
    updated: function() {
      this.$nextTick(function () {
        try {
          FONTPLUS.reload();
        } catch (error) {
          console.log(error.message);
        }
      })
    },
    mounted() {
      this.load();
    },
    methods: {
      load: function(params) {
        axios.get("/static/data/trips.csv")
          .then( response => {
            if (response.status == 200) {
              var data = response.data.split('\n');
              var keys = data[0].split(',');
              var list = [];
              for(var i=1;i<data.length-1;++i){
                var values = data[i].split(',');
                var trip = {};
                keys.forEach( function( key, idx ) {
                  trip[key] = values[idx]
                })
                if(trip) {
                  list.push(trip);
                }
              }
              this.trips = list.reverse();
            } else {
              alert(t("fail_to_get_data"))
            }
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Trip.vue